import { Modal, Title, Text, Button, Group, Stack, ThemeIcon } from '@mantine/core';
import { primaryColor } from '../../../../constants/theme';
import { IconExclamationCircle } from '@tabler/icons-react';

interface ErrorModalProps {
  isInError: boolean;
  errorMessage: string;
  dismissAction: () => void;
  retryAction: () => void;
  isLoading: boolean;
  testId?: string;
}

export const ErrorModal = ({
  isInError,
  errorMessage,
  dismissAction,
  retryAction,
  isLoading,
  testId = 'error-modal',
}: ErrorModalProps) => {
  return (
    <Modal
      opened={isInError}
      onClose={dismissAction}
      closeOnEscape={false}
      withCloseButton={false}
      centered
      data-testid={testId}
    >
      <Stack justify="center" align="center" gap={15} pb={10}>
        <ThemeIcon size={80} radius="100%" variant="light" color="red">
          <IconExclamationCircle size={44} />
        </ThemeIcon>
        <Title order={3} fw={700} ta="center">
          Something went wrong
        </Title>
        <Text c="dimmed" ta="center" size="md" lh={1.4}>
          {errorMessage}
        </Text>
        <Group w="100%" align="center" justify="center" gap={10}>
          <Button
            color={primaryColor}
            w="48%"
            variant="outline"
            onClick={() => dismissAction()}
            disabled={isLoading}
            data-testid={`${testId}-close`}
          >
            Close
          </Button>
          <Button
            color={primaryColor}
            w="48%"
            onClick={retryAction}
            loading={isLoading}
            data-testid={`${testId}-retry`}
          >
            Retry
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};
